<!-- 宣传教育 -->
<template>
<div class='cm_media_list_container'>
   <!-- 标题 -->
      <div class="cm_media_list_title">
        <h3>{{data.title}}</h3>
        <span>您的位置：{{data.title}}</span>
      </div>
      <!-- 内容 -->
      <div v-loading="loading" style="min-height:280px">
        <ul class="cm_media_list_content">
      <li v-for="item in dataList" :key="item.NEWS_ID" @click="toDetail(item.NEWS_ID,ele)">
        <!-- <img src="@/assets/img/bg-logo.png"  class="cm_media_bg_img"> -->
        <div class="cm_min_height">
          <el-image
      style="width: 100%; height: 100%"
      :src="baseUrl+item.ATTACHMENTPIC"
      :fit="imgType" class="cm_media_bg_img" v-if="item.ATTACHMENTPIC"></el-image>
        </div>
        <img src="@/assets/img/play.png"   class="cm_media_play_img">
        <span>保密视频</span>
      </li>
      
    </ul>
    <div class="cm_list_pagination" v-if="totalPage>1">
    <el-pagination
  background
  layout="prev, pager, next"
  :page-count="totalPage" @current-change="httpPost(current-page)" >
</el-pagination>
  </div>
      </div>
</div>
</template>

<script>
export default {
components: {},
props:["data"],
data() {
//这里存放数据
return {
  dataList:[],
  currentPage:"",
  totalPage:"",
  ele:"",
  baseUrl:window.SITE_CONFIG.baseUrl,
  imgType:"fill",
  loading:true
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
  toDetail(ID,data){
    this.$router.push({path:'/videoDetail/'+ID,query: {parentData:JSON.stringify(data)}})
  },
  httpPost(page) {
     var cData = this.ele.data
    if(page!=""&&page!=undefined&&page!=null&&page!=NaN){
      this.data.data.currentPage = page
      cData = this.ele.data
    }
    this.loading = true
      this.$http({
        url: this.$http.adornUrl(this.$store.state.comUrl),
        method: 'post',
        data: cData
      }).then(({ data }) => {
        if(data.data!=''&&data.data!=undefined&&data.data!=null){
          this.dataList = data.data.pdList
          this.currentPage = data.data.currentPage
          this.totalPage = data.data.totalPage
          this.ele.data = cData
          this.loading = false
        }
          
      });
    },
    loadItem() {
      let list = this.data.children;
      for (let i = 0; i < list.length; i++) {
        if (this.$route.path.indexOf(list[i].fullPath) == 0) {
          if(list[i].data==''||list[i].data==undefined||list[i].data==null){
            let children = list[i].children
             for (let i = 0; i < children.length; i++) {
                if (children[i].fullPath == this.$route.path) {
                  this.ele = children[i]
                  this.httpPost()
                  return false
                }
             }
          }else{
            this.ele = list[i]
            this.httpPost()
            return false
          }
          
        }
      }
    },
    initData(){
      if(this.data.data==''||this.data.data==undefined||this.data.data==null){
        this.loadItem()
      }else{
        this.ele = this.data
        this.httpPost()
      }
    },
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
  this.initData()
},

}
</script>
<style scoped>
.cm_media_list_container{
  width: 100%;
  background: #fff;
  min-height: 100%;
  padding: 0 20px;
}
.cm_media_list_title{
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #4379D3;
}
.cm_media_list_title>h3{
  font-size: 20px;
  font-weight: 500;
  color: #4379D3;
}
.cm_media_list_title>span{
  font-size: 14px;
  font-weight: 400;
  color: #000000;
}
.cm_media_list_content{
  display:flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.cm_media_list_content>li{
  width: 47%;
  margin: 10px;
  position: relative;
  cursor: pointer;
}
.cm_media_list_content>li>span{
  background: rgba(0,0,0,0.5);
  height: 43px;
  color: #fff;
  display: flex;
  align-items: center;
  padding: 0 10px;
  width: 100%;
  position:absolute;
  bottom:0;
  left: 0;
  right: 0;
}
.cm_media_play_img{
  position:absolute;
  top: 80px;
  left: 150px;
}
.cm_media_bg_img{
  width: 355px;
  height: 200px;
}
.cm_min_height{
  min-height: 200px;
}
.cm_list_pagination{
  margin: 20px 0;
  width: 100%;
  display:flex;
  justify-content: center;
}
</style>